import React from "react"
import { Tooltip } from "@mui/material"
import { ItemFeedbackGroup } from "../../../feedback/ItemFeedbackGroup"
import { ReviewIconBase, ReviewIconBaseProps } from "./ReviewIconBase"
import { StyledTooltipBase } from "./styles"
import { FeedbackItem } from "../../../types"

export type ReviewIconProps = ReviewIconBaseProps & {
  items?: FeedbackItem[]
}

const POPPER_PROPS = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [8, -8]
      }
    }
  ]
}

const SLOTS = { popper: StyledTooltipBase }

const ReviewIcon = React.forwardRef<HTMLSpanElement, ReviewIconProps>(
  ({ groupMode = false, items, correct, ...rest }, ref) => {
    if (groupMode) {
      return (
        <Tooltip
          title={<ItemFeedbackGroup size="sm" items={items} />}
          slots={SLOTS}
          placement="right-end"
          PopperProps={POPPER_PROPS}
        >
          <ReviewIconBase groupMode />
        </Tooltip>
      )
    }

    return <ReviewIconBase correct={correct} />
  }
)

export default ReviewIcon
